<template>
    <v-container fluid>
        <div v-if="!loading"> 
            <v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`" />
            </v-row>
			<!--table head-->
			<v-divider color="black" />
            <div v-if="awareness.length > 0">
                <!--table head-->
                <v-row class="subtitle-2 my-1" no-gutters>
                    <v-col class="text-left">{{'Trademark' | localize}} / {{'Segment' | localize}}</v-col>
                    <v-divider vertical color="black" />
                    <v-col v-for="(segment, i) in segments" :key="i" class="text-center">
                        {{ segment.name }}
                    </v-col>
                </v-row>
                <v-divider color="black" />
                <!--awareness tab-->
                <div v-for="trademark in trademarks" :key="trademark.i">
                    <v-row class="body-2" no-gutters>
                        <v-col class="text-left my-1">{{ trademark.name }}</v-col>
                        <v-divider vertical />
                        <v-col v-for="(segment, i) in segments" :key="i" class="text-center my-1">
                            {{ getAwareness(segment.id, trademark.id) }}%
                        </v-col>
                    </v-row>
                    <v-divider />
                </div>
            </div>
            <v-row v-else class="mt-8 px-4" justify="center">
                You haven't awareness yet!
            </v-row>
        </div>
        <!--!loading-->
        <v-row v-else justify="center" class="mt-12">
            <loader />
        </v-row>
    </v-container>
</template>
<script>
import { roundNumber } from '../../../functions/common';
import Information from '../../../layouts/Information.vue';
import Loader from '../../../layouts/Loader.vue';
export default {
    name: 'ReportAwareness',
    data() {
        return {
            text: {
                en: 'The brand awareness assessment indicates the percentage of consumers in each market segment who recognise the product brands available on the market.',
                ro: 'Evaluarea gradului de cunoaștere a mărcii indică procentul de consumatori din fiecare segment de piață care recunosc mărcile de produse disponibile pe piață.',
                ru: 'Оценка узнаваемости бренда показывает долю потребителей в каждом сегменте рынка, которые узнают представленные на рынке бренды продукции.'
            }
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        locale() {
            return this.$store.getters.locale;
        },
        game() {
			return this.$store.getters.game;
		},
        awareness() {
            return this.$store.getters.awareness;
        },
        segments() {
            let res = [];
            if (this.awareness.length > 0) {
              this.awareness.map((item) => {
                const inArr = res.find((it) => it.id == item.segment.id)
                if (!inArr) {
                    res.push({ id: item.segment.id,
                        name: item.segment.name });
                }
                });  
            }
            return res;
        },
        trademarks() {
            let res = [];
            if (this.awareness.length > 0) {
              this.awareness.map((item) => {
                const inArr = res.find((it) => it.id == item.trademark.id)
                if (!inArr) {
                    res.push({ id: item.trademark.id,
                        name: item.trademark.name });
                }
                });  
            }
            return res;
        }
    },
    methods: {
        getAwareness(segmentId, trademarkId) {
            let line = this.awareness.find((item) => item.segmentId == segmentId && item.trademarkId == trademarkId);
            let res = line ? roundNumber(line.awareness * 100, 2) : 0;
            return res;
        }
    },
    components: {Loader, Information},
    async created() {

		if (this.awareness?.length < 1 && this.game && Number(this.game.round) > 0) {

			const params = {
				gameId: this.game.id,
				round: this.game.round - 1,
			}
			try {
				//get last round awareness
				await this.$store.dispatch('fetchAwareness', params);
			}
			catch (error) {
				await this.$store.dispatch('setError', error.message);
			}
		}
	}
}
</script>